export const securityQuestions = {
  first_school: "您就读的第一所学校叫什么？",
  childhood_nickname: "您小时候的昵称是什么？",
  first_pet: "您第一只宠物叫什么？",
  memorable_place: "您最难忘的地方叫什么？",
} as const;
export type SecurityQuestionId = keyof typeof securityQuestions;
export type StoredMemberProfile = { realName: string; phone: string; email: string; wechat: string; version: number; updatedAt: string; phoneVerifiedAt?: string; emailVerifiedAt?: string };
/** Server-only credentials. Never spread this object into a public user response. */
export type StoredMemberSecurity = {
  withdrawalPasswordHash?: string;
  securityQuestion?: { questionId: SecurityQuestionId; answerHash: string };
  version: number;
  updatedAt: string;
};
export type MemberPaymentIdentity = { hasName: boolean; hasPhone: boolean; complete: boolean; verification: "unverified" };
export type MemberProfileResponse = {
  username: string; displayName: string; realName: string; phone: string; email: string; wechat: string;
  version: number; updatedAt: string | null; verification: "unverified"; paymentIdentity: MemberPaymentIdentity;
};
export type MemberProfileInput = Pick<MemberProfileResponse, "displayName" | "realName" | "phone" | "email" | "wechat" | "version">;
export type MemberSecurityResponse = {
  canManageCredentials: boolean; reason?: "telegram" | "unconfigured";
  withdrawalPasswordSet: boolean; securityQuestionSet: boolean; questionId: SecurityQuestionId | null;
  version: number; updatedAt: string | null;
};
export type WithdrawalPasswordInput = { currentPassword: string; currentWithdrawalPassword: string; newWithdrawalPassword: string; confirmWithdrawalPassword: string; version: number };
export type SecurityQuestionInput = { currentPassword: string; currentAnswer: string; questionId: string; answer: string; confirmAnswer: string; version: number };
export type MemberSecuritySection = "overview" | "withdrawal-password" | "security-question";

export function memberProfileErrors(input: MemberProfileInput) {
  const errors: Partial<Record<keyof MemberProfileInput, string>> = {};
  const name = input.displayName.trim();
  if (name.length < 2 || name.length > 24) errors.displayName = "昵称须为 2–24 个字符。";
  if (input.realName && (input.realName.trim().length < 2 || input.realName.trim().length > 60 || /[\p{Cc}\p{Cf}]/u.test(input.realName))) errors.realName = "姓名须为 2–60 个字符，不能包含控制字符。";
  if (input.phone && !/^\+?\d{7,15}$/.test(input.phone.trim().replace(/[\s()-]/g, ""))) errors.phone = "请填写 7–15 位手机号，可带 + 国家区号。";
  if (input.email && (input.email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.email.trim()))) errors.email = "请填写完整邮箱地址，例如 name@example.com。";
  if (input.wechat && !/^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/.test(input.wechat.trim())) errors.wechat = "微信号须为 6–20 位，以字母开头，可含数字、下划线和减号。";
  return errors;
}
export function withdrawalPasswordErrors(input: WithdrawalPasswordInput, exists: boolean) {
  const errors: Partial<Record<keyof WithdrawalPasswordInput, string>> = {};
  if (!input.currentPassword || input.currentPassword.length > 128) errors.currentPassword = "请输入当前登录密码（最多 128 位）。";
  if (exists && !/^\d{6}$/.test(input.currentWithdrawalPassword)) errors.currentWithdrawalPassword = "请输入原来的 6 位提现密码。";
  if (!/^\d{6}$/.test(input.newWithdrawalPassword)) errors.newWithdrawalPassword = "提现密码须为 6 位数字。";
  else if (exists && input.newWithdrawalPassword === input.currentWithdrawalPassword) errors.newWithdrawalPassword = "新提现密码不能与原密码相同。";
  if (!input.confirmWithdrawalPassword || input.confirmWithdrawalPassword !== input.newWithdrawalPassword) errors.confirmWithdrawalPassword = "两次输入的提现密码不一致。";
  return errors;
}
export function normalizeSecurityAnswer(value: string) { return value.normalize("NFKC").trim().replace(/\s+/g, " ").toLocaleLowerCase("en-US"); }
export function securityQuestionErrors(input: SecurityQuestionInput, exists: boolean) {
  const errors: Partial<Record<keyof SecurityQuestionInput, string>> = {};
  if (!input.currentPassword || input.currentPassword.length > 128) errors.currentPassword = "请输入当前登录密码（最多 128 位）。";
  if (exists && (!input.currentAnswer.trim() || input.currentAnswer.length > 128)) errors.currentAnswer = "请输入原密保答案（最多 128 位）。";
  if (!Object.hasOwn(securityQuestions, input.questionId)) errors.questionId = "请选择一个密保问题。";
  if (normalizeSecurityAnswer(input.answer).length < 2 || input.answer.length > 128 || /[\p{Cc}\p{Cf}]/u.test(input.answer)) errors.answer = "密保答案须为 2–128 个字符。";
  if (!input.confirmAnswer || normalizeSecurityAnswer(input.confirmAnswer) !== normalizeSecurityAnswer(input.answer)) errors.confirmAnswer = "两次填写的密保答案不一致。";
  return errors;
}
